jQuery(document).ready(function ($) {
  var $products_multiline = $(
    ".box-carousel-multiline-products .swiper-container"
  );

  if (!$products_multiline.length) return;

  $products_multiline.each(function (index, element) {
    new Swiper(element, {
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
      },
      spaceBetween: 15,
      slidesPerView: 2,
      slidesPerGroup: 2,
      slidesPerColumn: 3,
      slidesPerColumnFill: "row",
      speed: 550,
      //   centerInsufficientSlides: true,
      navigation: {
        nextEl: $(element).parent().find(".carousel-nav.next")[0],
        prevEl: $(element).parent().find(".carousel-nav.prev")[0],
      },
      breakpoints: {
        768: {
          spaceBetween: 30,
          slidesPerView: 3,
          slidesPerGroup: 3,
          slidesPerColumn: 3,
        },
      },
    });
  });
});
